import { Language } from '@ha/intl';
import { hasLanguage } from 'ha/helpers/routes/hasLanguage';
import { removeTrailingSlash } from 'ha/utils/urls/removeTrailingSlash';
import { removeLangPrefix } from 'ha/utils/urls/removeLangPrefix';

const onEnterLangIndex = (nextState, replace, callback) => {
  if (!hasLanguage(nextState)) {
    replace({
      ...nextState.location,
      pathname: removeTrailingSlash(nextState.location.pathname),
    });
  }

  if (nextState.params.lang === Language.en) {
    replace({
      ...nextState.location,
      pathname: removeLangPrefix(nextState.location.pathname),
    });
  }

  callback();
};

export { onEnterLangIndex };
